import Head from 'next/head'
import Link from 'next/link'
import Image from "next/legacy/image"

import styles from 'styles/pages/top/Home.module.scss'
import Layout from 'layout/Layout'
import SectionLayout from 'layout/Section'
import Heading from 'component/atoms/heading/_Heading'
import ButtonLink from 'component/atoms/button/_ButtonLink'
import Button from 'component/atoms/button/_Button'
import SupportedCameraList from 'component/organisms/elements/SupportedCameraList'
import HomeNoLoggedIn from 'component/organisms/common/HomeNoLoggedIn'

import { useIdNcVf0101 } from 'hooks/pages/useIdNcVf0101'
import { SERVICE_LIST } from 'const/pageDataConsts'
// 2024/04/22 mantis-32158 ダウンロードセンターURL変更 start
import { useLanguage } from 'hooks/common/useLanguage'
import Home from 'pages/home'
// 2024/04/22 mantis-32158 ダウンロードセンターURL変更 end

// ホーム（ログイン前）
const Top = ({ keycloak, updateKeycloak }) => {
  // 2024/04/22 mantis-32158 ダウンロードセンターURL変更 start
  const { getLanguage } = useLanguage()
  const DISPLAY_LANGUAGE = getLanguage()
  // 2024/04/22 mantis-32158 ダウンロードセンターURL変更 end
  const [
    t,
    Trans,
    newsList,
    isLoading,
    targetingCookie,
    downloadCenterFolder,
    topRedirectFile,
    redirectFile,
    // 2024/10/14 U2110SPEC-4262-お知らせ機能の追加改修 start
    dialogCreatorList,
    // 2024/10/14 U2110SPEC-4262-お知らせ機能の追加改修 end
    { handleClickLoginButton, handleClickCreateButton, handleClickSetCookie },
  ] = useIdNcVf0101(keycloak)

  if (isLoading) {
    return <></>
  }

  return (
    <HomeNoLoggedIn
      keycloak={keycloak}
      updateKeycloak={updateKeycloak}
        />
  )
}

export default Top
